"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeName = void 0;
var AttributeName;
(function (AttributeName) {
    AttributeName["ActivityDuration"] = "aktivitaetsdauer";
    AttributeName["TotalDuration"] = "gesamterlebnisdauer";
    AttributeName["TravelNights"] = "uebernachtung";
    AttributeName["Participants"] = "anzahlTeilnehmer";
    AttributeName["MinimumAge"] = "mindestalter";
    AttributeName["Rating"] = "anzahlSterne";
    AttributeName["Height"] = "hoehe";
    AttributeName["Length"] = "laenge";
    AttributeName["Depth"] = "tiefe";
})(AttributeName = exports.AttributeName || (exports.AttributeName = {}));
//# sourceMappingURL=attributeName.js.map